let settingsGeneration = 0;

export const getInstagramSettingsGeneration = () => settingsGeneration;

export const bumpInstagramSettingsGeneration = () => {
  settingsGeneration += 1;
  return settingsGeneration;
};

export const isStaleInstagramSettingsRequest = (generation: number) =>
  generation !== settingsGeneration;
